import { Button, notification, Popconfirm, Tooltip } from "antd";
import React, { Component } from "react";
import {
  EditOutlined,
  PlusCircleOutlined,
  LockOutlined,
  WalletOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import AddSalesModal from "./AddSalesModal";
import { AddCoinInSales } from "./AddCoinInSales";
import { UpdatePassword } from "./UpdatePassword";
import TableWrap from "../common/Table";
import BalanceModal from "../common/BalanceModal";
import TransactionModal from "../common/TransactionModal";
import CollectBalanceFromSales from "./CollectBalanceFromSales";
import CollectBalanceFromUser from "./CollectBalanceFromUser";
import { accountFreezeApi } from "../../Graphs/sales/accountFreezeApi";

export default class SalesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editSalesData: null,
      editModalVisible: false,
      addCoinData: null,
      addCoinModalVisible: false,
      passwordData: null,
      userSelectedDataForWallet: null,
      transactionData: null,
      collectAmountData: null,
      collectAmountDataFromUser: null,
      selectShow: false,
    };
  }
  modalRef;
  handleDetailsModalclose() {
    this.setState({
      editSalesData: null,
      editModalVisible: false,
      addCoinData: null,
      addCoinModalVisible: false,
      passwordData: null,
      userSelectedDataForWallet: null,
      transactionData: null,
      collectAmountData: null,
      collectAmountDataFromUser: null,
    });
  }
  showModal(item) {
    this.setState({
      editSalesData: item,
      editModalVisible: true,
    });
  }

  addBalanceInSales(item) {
    this.setState({
      addCoinData: item,
      addCoinModalVisible: true,
    });
  }
  changePasword(item) {
    this.setState({
      passwordData: item,
    });
  }
  async unfreezeSalesman(item) {
    try {
      const { loginUserData, authToken } = this.props;
      let city = loginUserData.role == "Sub_admin" ? loginUserData.city : "";
      const responseData = await accountFreezeApi(authToken, item.id, city);

      if (responseData.status == 200) {
        notification["success"]({
          message: "unfreeze Salesman",
          description: "Successfully unfreeze",
        });
        this.props.reload();
      }
    } catch (error) {
      notification["error"]({
        message: "unfreeze Salesman",
        description: "Something went wrong",
      });
    }
  }
  showWalletModal(item) {
    this.setState({
      userSelectedDataForWallet: item,
    });
  }

  transaction(item) {
    this.setState({
      transactionData: item,
    });
  }
  collectAmount(item) {
    this.setState({
      collectAmountData: item,
    });
  }

  collectAmountFromUser(item) {
    this.setState({
      collectAmountDataFromUser: item,
    });
  }

  columns = [
    {
      title: "Sr. No.",
      width: 100,
      key: "serial_number",
      render: (text, item, index) => {
        return (
          <div key={"sno" + index}>
            <span>{++index}</span>
          </div>
        );
      },
    },
    {
      title: "Name",
      width: 200,
      key: "name",
      render: (text, item, index) => {
        return (
          <div key={"name" + index}>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column" style={{ marginTop: "5px" }}>
                {item.first_name + " " + item.last_name}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Arabic Name",
      width: 200,
      key: "arabic name",

      render: (text, item, index) => {
        return (
          <div key={"arabic name" + index}>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column" style={{ marginTop: "5px" }}>
                {item.arabic_name}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "email",
      width: 250,
      dataIndex: "email",
      render: (text, item, index) => {
        return <div key={"email" + index}>{item.email ? item.email : "-"}</div>;
      },
    },
    {
      title: "Mobile",
      key: "mobile",
      width: 150,
      render: (text, item, index) => {
        return <div>{item.phone ? item.phone : "-"}</div>;
      },
    },
    {
      title: "City",
      key: "city",
      render: (text, item, index) => {
        return <div>{item.user_city ? item.user_city.name : "-"}</div>;
      },
    },
    {
      title: "Balance",
      key: "wallet balance",
      width: 150,
      render: (text, item, index) => {
        return <div>{item.total_balance}</div>;
      },
    },
    {
      title: "Outstanding Balance",
      key: "collected_balance",
      width: 130,
      render: (text, item, index) => {
        return (
          <div style={{ color: "red" }}>
            {item.outstanding_balance ? item.outstanding_balance : "0"}
          </div>
        );
      },
    },
    {
      title: "Is Freeze",
      key: "freeze_user",
      width: 130,
      render: (text, item, index) => {
        return item.freeze ? (
          <span
            style={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "15px",
              padding: "5px 10px",
            }}
          >
            Yes
          </span>
        ) : (
          <span
            style={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "15px",
              padding: "5px 10px",
            }}
          >
            No
          </span>
        );
      },
    },

    {
      title: "Actions",
      width: 220,
      key: "action",
      render: (text, item, index) => {
        return (
          <div
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {
              <div>
                <Tooltip placement="bottom" title="Edit">
                  <Button
                    shape="circle"
                    icon={<EditOutlined />}
                    onClick={() => {
                      this.showModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            }
            <div>
              <Tooltip placement="bottom" title="Add Balance">
                <Button
                  shape="circle"
                  icon={<PlusCircleOutlined />}
                  onClick={() => {
                    this.addBalanceInSales(item);
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <Tooltip placement="bottom" title="Change Password">
                <Button
                  shape="circle"
                  icon={<LockOutlined />}
                  onClick={() => {
                    this.changePasword(item);
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <Tooltip placement="bottom" title="Transactions">
                <Button
                  shape="circle"
                  icon={<WalletOutlined />}
                  onClick={() => {
                    this.transaction(item);
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <Tooltip placement="bottom" title="Collect Amount">
                <Button
                  shape="circle"
                  icon={<DollarCircleOutlined />}
                  disabled={item.outstanding_balance <= 0}
                  onClick={() => {
                    this.collectAmount(item);
                  }}
                />
              </Tooltip>
            </div>
            {/* {
              <div>
                <Tooltip placement="bottom" title="Delete Salesman">
                  <Popconfirm
                    onConfirm={() => this.props.delete(item)}
                    title="Are you sure you want to delete Salesman"
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </div>
            } */}
            <div>
              <Tooltip placement="bottom" title="Collect Amount From User">
                <Button
                  shape="circle"
                  icon={<WalletOutlined />}
                  onClick={() => {
                    this.collectAmountFromUser(item);
                  }}
                />
              </Tooltip>
            </div>
            <div>
              <Tooltip placement="bottom" title="Unfreeze Salesman">
                <Button
                  className={item.freeze ? "unfreeze-btn" : ""}
                  shape="circle"
                  disabled={item.freeze ? false : true}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                      width={16}
                      className="unfreeze-icon"
                    >
                      <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z" />
                    </svg>
                  }
                  onClick={() => {
                    this.unfreezeSalesman(item);
                  }}
                />
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <TableWrap
          data={this.props.salesList}
          columns={this.columns}
          isLoading={this.props.isLoading}
          total={this.props.totalsales}
          pagination={this.props.pagination}
          handleTableChange={this.props.handleTableChange}
          scroll={{ x: 1000 }}
        />
        {this.state.editModalVisible && (
          <AddSalesModal
            visible={this.state.editModalVisible}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.editSalesData}
            updateSalesUser={this.props.updateSalesUser}
            selectShow={this.state.selectShow}
            loginUserData={this.props.loginUserData}
          />
        )}
        {this.state.userSelectedDataForWallet ? (
          <BalanceModal
            visible={this.state.userSelectedDataForWallet}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.userSelectedDataForWallet}
            // onSubmit={this.editSubmit}
          />
        ) : null}
        {this.state.addCoinModalVisible ? (
          <AddCoinInSales
            visible={this.state.addCoinModalVisible}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.addCoinData}
            authToken={this.props.authToken}
            reload={this.props.reload}
            loginUserData={this.props.loginUserData}
          />
        ) : null}
        {this.state.passwordData ? (
          <UpdatePassword
            visible={this.state.passwordData}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.passwordData}
            authToken={this.props.authToken}
          />
        ) : null}

        {this.state.transactionData ? (
          <TransactionModal
            visible={this.state.transactionData}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.transactionData}
            authToken={this.props.authToken}
          />
        ) : null}
        {this.state.collectAmountData ? (
          <CollectBalanceFromSales
            visible={this.state.collectAmountData}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.collectAmountData}
            authToken={this.props.authToken}
            reload={this.props.reload}
            loginUserData={this.props.loginUserData}
          />
        ) : null}

        {this.state.collectAmountDataFromUser ? (
          <CollectBalanceFromUser
            visible={this.state.collectAmountDataFromUser}
            handleCancel={this.handleDetailsModalclose.bind(this)}
            handleOk={this.handleDetailsModalclose.bind(this)}
            onClose={this.handleDetailsModalclose.bind(this)}
            isLoading={this.state.isLoading}
            data={this.state.collectAmountDataFromUser}
            authToken={this.props.authToken}
            reload={this.props.reload}
          />
        ) : null}
      </>
    );
  }
}
